import protection from "../images/protection.png";

export const investmentPlans = [
  {
    name: "Starter Plan",
    image: protection,
    price: "$50 - $999",
    amount: 50,
    duration: 1,
    durationDisplay: "1 day",
    profit: 15,
    hardware: "2x CPU Cores | 1x GPU (NVIDIA T4)",
    efficiency: "75% Guaranteed",
    chains: "Ethereum, BSC, Polygon",
    tps: "Compliance-ready staking with control over validators, MEV optimization, and liquidity access.",
    maxTps: 250,
    specs: [
      "4GB DDR4 RAM",
      "100GB SSD Storage",
      "1Gbps Network",
      "Basic Cooling System"
    ]
  },
  {
    name: "Amarteur Plan",
    image: protection,
    price: "$2,000 - $3,999",
    amount: 2000,
    duration: 2,
    durationDisplay: "2 days",
    profit: 40,
    hardware: "4x CPU Cores | 2x GPU (NVIDIA RTX 3060)",
    efficiency: "85% Guaranteed",
    chains: "Ethereum, Solana, Avalanche",
    tps: "Custom staking for high-volume clients with L1 integration and scalable TVL growth.",
    maxTps: 850,
    specs: [
      "16GB DDR4 RAM",
      "500GB NVMe SSD",
      "2.5Gbps Network",
      "Liquid Cooling"
    ]
  },
  {
    name: "Professional Plan",
    image: protection,
    price: "$4,000 - $9,999",
    amount: 4000,
    duration: 4,
    durationDisplay: "4 days",
    profit: 60,
    hardware: "8x CPU Cores | 4x GPU (NVIDIA RTX 4090)",
    efficiency: "94% Guaranteed",
    chains: "Ethereum, Solana, Sui",
    tps: "Advanced DeFi products with dynamic collateral models for institutional-grade deployments.",
    maxTps: 2100,
    specs: [
      "32GB DDR5 RAM",
      "1TB NVMe SSD",
      "10Gbps Network",
      "Enterprise Cooling"
    ]
  },
  {
    name: "Expert Plan",
    image: protection,
    price: "$10,000 - unlimited",
    amount: 10000,
    duration: 7,
    durationDisplay: "7 days",
    profit: 80,
    hardware: "Allocated Gold Storage & Digital Contracts",
    efficiency: "Gold-backed Stability",
    chains: "Gold, Silver, Platinum",
    tps: "Direct exposure to rare metals with secure, insured storage and digital redemption options.",
    maxTps: 100,
    specs: [
      "Allocated Bullion Accounts",
      "London Good Delivery Certified",
      "Audited Vault Access",
      "Hedge Against Inflation"
    ]
  }
];
